//
// server-map.js
// jsVectorMap world map with RDP Arena server location pins
//

import jsVectorMap from 'jsvectormap/dist/jsvectormap.esm.js';

// world.js uses `jsVectorMap` as a bare global — expose on window before requiring it.
// require() is called inline (after imports) so the assignment happens first.
window.jsVectorMap = jsVectorMap;
require('jsvectormap/dist/maps/world');

const mapEl = document.getElementById('rdp-world-map');

if (mapEl) {
  const markers = [
    // USA — 22 cities
    { name: 'New York, NY',       coords: [40.7128,   -74.0060] },
    { name: 'Newark, NJ',         coords: [40.7357,   -74.1724] },
    { name: 'Philadelphia, PA',   coords: [39.9526,   -75.1652] },
    { name: 'Ashburn, VA',        coords: [39.0437,   -77.4875] },
    { name: 'Charlotte, NC',      coords: [35.2271,   -80.8431] },
    { name: 'Atlanta, GA',        coords: [33.7490,   -84.3880] },
    { name: 'Miami, FL',          coords: [25.7617,   -80.1918] },
    { name: 'West Palm Beach, FL',coords: [26.7153,   -80.0534] },
    { name: 'Columbus, OH',       coords: [39.9612,   -82.9988] },
    { name: 'Chicago, IL',        coords: [41.8781,   -87.6298] },
    { name: 'Dallas, TX',         coords: [32.7767,   -96.7970] },
    { name: 'Kansas City, KS',    coords: [39.0997,   -94.5786] },
    { name: 'Denver, CO',         coords: [39.7392,  -104.9903] },
    { name: 'Salt Lake City, UT', coords: [40.7608,  -111.8910] },
    { name: 'Phoenix, AZ',        coords: [33.4484,  -112.0740] },
    { name: 'Las Vegas, NV',      coords: [36.1699,  -115.1398] },
    { name: 'Los Angeles, CA',    coords: [34.0522,  -118.2437] },
    { name: 'Walnut, CA',         coords: [34.0195,  -117.8686] },
    { name: 'Santa Clara, CA',    coords: [37.3541,  -121.9552] },
    { name: 'San Jose, CA',       coords: [37.3382,  -121.8863] },
    { name: 'Bend, OR',           coords: [44.0582,  -121.3153] },
    { name: 'Seattle, WA',        coords: [47.6062,  -122.3321] },
    // Canada — 4 cities
    { name: 'Hamilton, ON',       coords: [43.2557,   -79.8711] },
    { name: 'Toronto, ON',        coords: [43.6532,   -79.3832] },
    { name: 'Montreal, QC',       coords: [45.5017,   -73.5673] },
    { name: 'Vancouver, BC',      coords: [49.2827,  -123.1207] },
    // Europe
    { name: 'London, UK',         coords: [51.5074,    -0.1278] },
    { name: 'Amsterdam, NL',      coords: [52.3676,     4.9041] },
    { name: 'Düsseldorf, DE',     coords: [51.2217,     6.7762] },
    { name: 'Frankfurt, DE',      coords: [50.1109,     8.6821] },
    { name: 'Zurich, CH',         coords: [47.3769,     8.5417] },
    // Oceania
    { name: 'Sydney, AU',         coords: [-33.8688,  151.2093] },
  ];

  new jsVectorMap({
    selector: '#rdp-world-map',
    map: 'world',
    backgroundColor: 'transparent',
    draggable: false,
    zoomButtons: false,
    zoomOnScroll: false,
    showTooltip: false,
    regionStyle: {
      initial: {
        fill: '#d6e0f0',
        stroke: '#ffffff',
        'stroke-width': 0.5,
        'fill-opacity': 1,
      },
      hover: {
        fill: '#bfcfe8',
        cursor: 'default',
      },
    },
    markerStyle: {
      initial: {
        r: 4,
        fill: '#335EEA',
        'fill-opacity': 1,
        stroke: '#335EEA',
        'stroke-width': 2,
        'stroke-opacity': 0.5,
      },
      hover: {
        r: 5,
        fill: '#6a8ef7',
        stroke: '#6a8ef7',
        'stroke-opacity': 0.4,
        cursor: 'default',
      },
    },
    markers,
  });

  // jsVectorMap's built-in tooltip does not reliably position for markers.
  // We create our own using position:fixed so it is never clipped by stacking contexts.
  const tip = document.createElement('div');
  tip.className = 'jvm-tooltip';
  tip.style.position = 'fixed';
  tip.style.pointerEvents = 'none';
  tip.style.zIndex = '9999';
  document.body.appendChild(tip);

  setTimeout(() => {
    mapEl.querySelectorAll('circle.jvm-marker').forEach((el, i) => {
      el.style.animationDelay = `${(i * 0.15).toFixed(2)}s`;

      el.addEventListener('mouseenter', (e) => {
        tip.textContent = markers[i].name;
        tip.classList.add('active');
        tip.style.top  = `${e.clientY - tip.offsetHeight - 10}px`;
        tip.style.left = `${e.clientX - tip.offsetWidth / 2}px`;
      });

      el.addEventListener('mousemove', (e) => {
        tip.style.top  = `${e.clientY - tip.offsetHeight - 10}px`;
        tip.style.left = `${e.clientX - tip.offsetWidth / 2}px`;
      });

      el.addEventListener('mouseleave', () => {
        tip.classList.remove('active');
      });
    });
  }, 500);
}